import React from 'react';
import Slider from 'react-slick';
import './Home.css';

const Home = () => {
  const images = [
    'https://res-console.cloudinary.com/kushagragupta/media_explorer_thumbnails/791236641bd47840069fc6de237d2b91/detailed', // School building
    'https://res-console.cloudinary.com/kushagragupta/media_explorer_thumbnails/fa9977c1df239f565afb57d0fb952bff/detailed'
  ];


  const settings = {
    dots: true, // Show navigation dots
    infinite: true,
    speed: 1000, // 1 second for transition
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Automatically transition
    autoplaySpeed: 2000, // Time between slides in milliseconds
    fade: true, // Fade transition effect
    cssEase: 'linear', // Smooth fade effect
  };

  return (
    <div className="home">
      {/* Image Carousel */}
      <div className="carousel-container">
        <Slider {...settings}>
          {images.map((image, index) => (
            <div key={index}>
              <img src={image} alt={`Slide ${index + 1}`} className="carousel-image" />
            </div>
          ))}
        </Slider>
      </div>

      {/* Hero Section */}
      <header className="hero">
        <h1>GRAM VIKAS INTER COLLEGE, KHUTHAN JAUNPUR</h1>
        <p>Established in 1952 | Hindi Medium | Grades 6–12 | Co-educational</p>
      </header>

      {/* About Section */}
      <section className="about">
        <h2>About Our College</h2>
        <p>
          GRAM VIKAS INTER COLLEGE KHUTHAN JAUNPUR was established in 1952 and is managed by Pvt. Aided.
          Located in a rural area of KHUTHAN block, JAUNPUR district, Uttar Pradesh. It offers education
          from grades 6 to 12. Hindi is the medium of instruction. The academic session starts in April.
        </p>
      </section>

      {/* Details Grid */}
      <section className="details-grid">
        <div><strong>Building:</strong> Private, 25 Classrooms</div>
        <div><strong>Condition:</strong> All classrooms in good condition</div>
        <div><strong>Extra Rooms:</strong> 2 non-teaching, 1 Headmaster's room</div>
        <div><strong>Boundary Wall:</strong> Pucca</div>
        <div><strong>Electricity:</strong> Yes</div>
        <div><strong>Water:</strong> Hand Pump (Functional)</div>
        <div><strong>Toilets:</strong> 3 Boys, 3 Girls (All Functional)</div>
        <div><strong>Playground:</strong> Not Available</div>
        <div><strong>Library:</strong> Available (100 books)</div>
        <div><strong>Computers:</strong> 10 Functional</div>
        <div><strong>CALL Lab:</strong> Not Available</div>
        <div><strong>Mid-Day Meal:</strong> Provided & Prepared in School Premises</div>
      </section>

      {/* Map Section */}
      <section className="map">
        <h2>Find Us on Map</h2>
        <iframe
          title="College Location"
          src="https://maps.google.com/maps?q=GRAM+VIKAS+INTER+COLLEGE+KHUTHAN+JAUNPUR&t=&z=15&ie=UTF8&iwloc=&output=embed"
          frameBorder="0"
          allowFullScreen=""
        ></iframe>
        <a href="https://maps.app.goo.gl/dasjgabZsGmfsbZU8" target="_blank" rel="noreferrer">
          Open in Google Maps
        </a>
      </section>
    </div>
  );
};

export default Home;

